import { Skeleton } from '@/components/atoms';
import React from 'react';
import { StyleSheet, View, type DimensionValue } from 'react-native';
import { GUEST_LIST_SKELETON_COUNT } from '../../constants/guestLayout';
import { GuestPropertyCardSkeleton } from './GuestPropertyCardSkeleton';

export interface GuestListScreenSkeletonProps {
  readonly columnWidth: DimensionValue;
  /** Match list: no gutter bleed when one card per row. */
  readonly isSingleColumn?: boolean;
}

const SKELETON_KEYS = Array.from(
  { length: GUEST_LIST_SKELETON_COUNT },
  (_, index) => `guest-list-skeleton-${index}`,
);

/** Full guest list page skeleton: greeting + responsive card grid. */
export function GuestListScreenSkeleton({
  columnWidth,
  isSingleColumn = false,
}: Readonly<GuestListScreenSkeletonProps>) {
  return (
    <View style={styles.container}>
      <Skeleton width={220} height={36} borderRadius={6} />
      <View style={[styles.grid, isSingleColumn && styles.gridSingleColumn]}>
        {SKELETON_KEYS.map((key) => (
          <View
            key={key}
            style={[
              styles.gridItem,
              isSingleColumn && styles.gridItemSingleColumn,
              { width: columnWidth },
            ]}
          >
            <GuestPropertyCardSkeleton fullWidth />
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: '100%',
    gap: 24,
    minWidth: 0,
    alignSelf: 'stretch',
  },
  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginHorizontal: -8,
    width: '100%',
  },
  gridSingleColumn: {
    marginHorizontal: 0,
  },
  gridItem: {
    paddingHorizontal: 8,
    marginBottom: 16,
    maxWidth: '100%',
    alignSelf: 'stretch',
    minWidth: 0,
  },
  gridItemSingleColumn: {
    paddingHorizontal: 0,
  },
});
